import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	Button,
	Intent,
	Alert,
} from '@blueprintjs/core';

import AddEditCashRegisters from './AddEditCashRegisters';
import { addCashRegister }  from '../../slices/CashRegisterSlice';
import { saveCashRegister } from '../../api/CashRegisters';

import { ResultHeader, ResultHeaderWithSort, Result, TextFilter } from './ResultComponents';

function Results(props) {
	const {
		table_items,
		table_items_sort_ids,
		table_items_sort_field,
		table_items_sort_direction,
		setTableItemsSort,
		openAddEditItemDialog,
		tableItemsFilters,
		handleFilterChange,
		business_premises,
		warehouses,
		deleteItem,
	} = props;
	
	const sort_props = {
		setTableItemsSort:       setTableItemsSort,
		tableItemsSortField:     table_items_sort_field,
		tableItemsSortDirection: table_items_sort_direction,
	};
	
	return <div className='results mt-4 mb-4'>
		<div className='results-table'>
			<ResultHeader columnIdx={1} title='' />
			<ResultHeader columnIdx={2} title='Urejanje' />
			<ResultHeaderWithSort
				columnIdx={3} {...sort_props} title='Interna šifra' fieldName='internal_code' />
			<ResultHeaderWithSort
				columnIdx={4} {...sort_props} title='Identifikator blagajne (FURS)' fieldName='furs_code' />
			<ResultHeaderWithSort
				columnIdx={5} {...sort_props} title='Naziv' fieldName='title' />
			<ResultHeaderWithSort
				columnIdx={6} {...sort_props} title='Poslovni prostor' fieldName='business_premise' />
			<ResultHeaderWithSort
				columnIdx={7} {...sort_props} title='Skladišče' fieldName='warehouse' />
		</div>
		
		<div className='results-table filters-row'>
			<Result columnIdx={1} />
			<Result columnIdx={2} />
			<Result columnIdx={3} child={
				<TextFilter
					value={tableItemsFilters.internal_code}
					onChange={ event => handleFilterChange('internal_code', event) } />
			} />
			<Result columnIdx={4} child={
				<TextFilter
					value={tableItemsFilters.furs_code}
					onChange={ event => handleFilterChange('furs_code', event) } />
			} />
			<Result columnIdx={5} child={
				<TextFilter
					value={tableItemsFilters.title}
					onChange={ event => handleFilterChange('title', event) } />
			} />
			<Result columnIdx={6} />
			<Result columnIdx={7} />
		</div>
		
		{table_items_sort_ids.map((id, idx) => {
			const item = table_items[id];
			if (item.id_business_premise === undefined) return null;
			
			return <div className='results-table' key={'items-result--result-' + id}>
				<Result columnIdx={1} child={
					item.serial_internal_code
				} />
				<Result columnIdx={2} child={
					<>
						<Button
							icon='edit'
							intent='primary'
							minimal={true}
							small={true}
							onClick={() => openAddEditItemDialog(item)} />
						<Button
							icon='trash'
							intent='danger'
							minimal={true}
							small={true}
							onClick={() => deleteItem(item)} />
					</>
				} />
				<Result columnIdx={3} child={
					item.internal_code
				} />
				<Result columnIdx={4} child={
					item.furs_code
				} />
				<Result columnIdx={5} child={
					item.title
				} />
				<Result columnIdx={6} child={
					business_premises[item.id_business_premise].furs_code
				} />
				<Result columnIdx={7} child={
					warehouses[item.id_warehouse].title
				} />
			</div>;
		})}
	</div>;
}

class CashRegisters extends Component {
	constructor(props) {
		super(props);
		
		this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
		this.setTableItemsSort         = this.setTableItemsSort        .bind(this);
		this.refreshTableItemsSort     = this.refreshTableItemsSort    .bind(this);
		this.filterTableItems          = this.filterTableItems         .bind(this);
		this.handleFilterChange        = this.handleFilterChange       .bind(this);
		this.openAddEditItemDialog     = this.openAddEditItemDialog    .bind(this);
		this.closeAddEditItemDialog    = this.closeAddEditItemDialog   .bind(this);
		this.deleteItem                = this.deleteItem               .bind(this);
		
		const {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
		} = this.updateTableItemsFromProps(props);
		
		this.state = {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
			table_items_sort_field: '',
			table_items_sort_direction: 'ASC',
			table_items_filters: {
				internal_code: '',
				furs_code:     '',
				title:         '',
			},
			add_edit_item_dialog_open: false,
			add_edit_item_dialog_item: null,
			item_delete_requested: null,
		};
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.cash_registers != this.state.table_items) {
			this.setState(
				this.updateTableItemsFromProps(this.props)
			);
		}
	}
	
	updateTableItemsFromProps(props) {
		const ids = Object.keys(props.cash_registers);
		
		let sort_ids = [];
		
		if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) {
			for (let i=0; i<this.state.table_items_sort_ids.length; i++) {
				const id = this.state.table_items_sort_ids[i];
				if (ids.indexOf(id) != -1) {
					sort_ids.push(id);
				}
			}
		}
		
		for (let i=0; i<ids.length; i++) {
			const id = ids[i];
			if (sort_ids.indexOf(id) == -1) {
				sort_ids.push(id);
			}
		}
		
		//TODO refresh sorting
		//TODO call this.filterTableItems(new_filters);
		
		return {
			table_items: props.cash_registers,
			table_items_sort_ids: sort_ids,
			table_items_filtered_ids: ids,
		};
	}
	
	setTableItemsSort(field) {
		let direction = 'ASC';
		if (this.state.table_items_sort_field == field) {
			direction = (this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC');
		}
		
		this.setState({
			table_items_sort_field:     field,
			table_items_sort_direction: direction,
		});
		
		this.refreshTableItemsSort(field, direction);
	}
	
	refreshTableItemsSort(field, direction, table_items_filtered_ids) {
		table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
		
		const ids = table_items_filtered_ids;
		ids.sort((a_key, b_key) => {
			let a, b;
			
			if (field == 'business_premise') {
				a = this.props.business_premises[this.state.table_items[a_key].id_business_premise].furs_code;
				b = this.props.business_premises[this.state.table_items[b_key].id_business_premise].furs_code;
			}
			else if (field == 'warehouse') {
				a = this.props.warehouses[this.state.table_items[a_key].id_warehouse].title;
				b = this.props.warehouses[this.state.table_items[b_key].id_warehouse].title;
			}
			else if (field == 'title') {
				a = this.state.table_items[a_key][field];
				b = this.state.table_items[b_key][field];
				
				return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
			}
			else {
				a = this.state.table_items[a_key][field];
				b = this.state.table_items[b_key][field];
			}
			
			return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
		});
		
		this.setState({
			table_items_sort_ids: ids,
		});
	}
	
	filterTableItems(filters) {
		const filters_internal_code = filters.internal_code.toUpperCase();
		const filters_furs_code     = filters.furs_code    .toUpperCase();
		const filters_title         = filters.title        .toUpperCase();
		
		const ids = Object.keys(this.state.table_items);
		const filtered_ids = ids.filter(id => {
			const item = this.state.table_items[id];
			
			if (filters_internal_code != '' && item.internal_code.toUpperCase().indexOf(filters_internal_code) == -1) {
				return false;
			}
			
			if (filters_furs_code != '' && item.furs_code.toUpperCase().indexOf(filters_furs_code) == -1) {
				return false;
			}
			
			if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) {
				return false;
			}
			
			return true;
		});
		
		this.setState({
			table_items_filtered_ids: filtered_ids,
			table_items_filters:      filters,
		});
		
		this.refreshTableItemsSort(
			this.state.table_items_sort_field,
			this.state.table_items_sort_direction,
			filtered_ids
		);
	}
	
	handleFilterChange(field_name, event) {
		const new_filters = {
			internal_code: this.state.table_items_filters.internal_code,
			furs_code:     this.state.table_items_filters.furs_code,
			title:         this.state.table_items_filters.title,
		};
		
		let val = event;
		if (val instanceof Object) {
			val = event.target.value;
		}
		new_filters[field_name] = val;
		
		this.filterTableItems(new_filters);
	}
	
	openAddEditItemDialog(item) {
		this.setState({ add_edit_item_dialog_open: true, add_edit_item_dialog_item: item });
	}
	async closeAddEditItemDialog(item) {
		this.setState({ add_edit_item_dialog_open: false });
		
		if (item !== undefined) {
			this.props.dispatch(addCashRegister(item));
			
			const new_item = await saveCashRegister(this.props.api_url, item, this.props.token);
			this.props.dispatch(addCashRegister(new_item));
		}
	}
	deleteItem(item) {
		this.setState({ item_delete_requested: item, token: this.props.token });
	}
	
	render() {
		if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
		
		return <>
			{this.state.item_delete_requested === null ? null :
				<Alert
					cancelButtonText='Prekliči'
					confirmButtonText='Briši'
					canEscapeKeyCancel={true}
					canOutsideClickCancel={true}
					icon='trash'
					intent={Intent.DANGER}
					isOpen={true}
					onConfirm={() => {
						//this.props.dispatch(deleteCashRegister(this.state.item_delete_requested.id_cash_register));
						this.setState({ item_delete_requested: null });
					}}
					onCancel={() => {
						this.setState({ item_delete_requested: null });
					}}>
					Ali res želite izbrisati ta zapis?
				</Alert>
			}
			
			{!this.state.add_edit_item_dialog_open ? null :
				<AddEditCashRegisters
					closeAddEditItemDialog={this.closeAddEditItemDialog}
					item={this.state.add_edit_item_dialog_item} />
			}
			
			<div className='flex flex-col flex-grow cash-registers-list'>
				<div className='pl-4 pt-4'>
					<Button intent='primary' icon='plus' onClick={() => this.openAddEditItemDialog(null)}>
						Nov vnos
					</Button>
				</div>
				
				<div className='flex-1 pl-4 pr-4'>
					<div className='flex-grow overflow-y-auto' style={{ flexBasis: '0' }}>
						<Results
							table_items={this.state.table_items}
							table_items_sort_ids={this.state.table_items_sort_ids}
							table_items_sort_field={this.state.table_items_sort_field}
							table_items_sort_direction={this.state.table_items_sort_direction}
							setTableItemsSort={this.setTableItemsSort}
							openAddEditItemDialog={this.openAddEditItemDialog}
							tableItemsFilters={this.state.table_items_filters}
							handleFilterChange={this.handleFilterChange}
							business_premises={this.props.business_premises}
							warehouses={this.props.warehouses}
							deleteItem={this.deleteItem} />
					</div>
				</div>
			</div>
		</>;
	}
}
CashRegisters.propTypes = {
};

function mapStateToProps(state) {
	return {
		api_url:           state.BusinessSlice.api_url,
		cash_registers:    state.CashRegisterSlice.cash_registers,
		business_premises: state.CodeTablesSlice.business_premises,
		warehouses:        state.CodeTablesSlice.warehouses,
		token:             state.UserSlice.token,
		user:              state.UserSlice.user,
	};
}

export default connect(mapStateToProps)(CashRegisters);
